/**
 * Terms Validation Module
 *
 * Keeps submit buttons marked with the 'disabled-until-terms' attribute disabled
 * (greyed out) until the related terms-of-service checkbox is checked.
 */

export const initTermsValidation = () => {
	const buttons = document.querySelectorAll('button[disabled-until-terms]');

	if (!buttons.length) {
		return;
	}

	buttons.forEach((button) => {
		const form = button.closest('form');
		const checkbox = form ? form.querySelector('#terms') : document.getElementById('terms');

		if (!checkbox) {
			return;
		}

		const syncButtonState = () => {
			if (checkbox.checked) {
				button.removeAttribute('disabled');
			} else {
				button.setAttribute('disabled', true);
			}
		};

		checkbox.addEventListener('change', syncButtonState);
		syncButtonState();
	});
};
